import { useEffect, useState } from 'react';
import swal from 'sweetalert'; 
import ApiFetch from '../../../utils/fetch';
import Loading from '../../../components/loading/loading';
import Btn from '../../../components/btn/btn';

const fetch = new ApiFetch();

const BotonSwal = ({reclamo, onUpdate}) => {
  const [loading, setLoading] = useState(false);
  const [showButton, setShowButton] = useState(true);

  useEffect(() => {
    if (reclamo?.Cancelar === 0) {
      setShowButton(false);
    }
  }, [reclamo]);

  const postCancelarReclamo = async () => {
    try {
      setLoading(true);

      const body = JSON.stringify({
        idTramite: reclamo?.IdTramite,
        idPrestacion: reclamo?.IdPrestacion,
        idServicio: reclamo?.IdServicio,
        idTipoFallaDec: reclamo?.IdTipoFallaDec,
      });

      const data = await fetch.POST(body, '/reclamos/cancelar');

      if (data?.status === 200) {
        swal(`Se ha cancelado su Reclamo del servicio ${reclamo?.DsServicio}`, {
          icon: 'success',
        });
        setShowButton(false);
            if(onUpdate) onUpdate();
      } else {
        swal(data?.message || 'No se pudo cancelar el reclamo.', {
          icon: 'error',
        });
      }
    } catch (error) {
      swal('No fue posible cancelar el Reclamo', { icon: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleClick = () => {
    swal({
      title: '¿Está seguro que desea cancelar el reclamo?',
      text: `Esta acción no se puede deshacer. El reclamo del servicio ${reclamo?.DsServicio} será eliminado.`,
      icon: 'warning',
      buttons: {
      cancel: {
        text: "No, volver",
        visible: true,
        className: "",
        closeModal: true,
      },
      confirm: {
        text: "Sí, cancelar",
        value: true,
        visible: true,
        className: "",
        closeModal: true
      }
    },
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        await postCancelarReclamo();
      } else {
        swal('La cancelación fue anulada. Su reclamo sigue activo.', {
          icon: 'info',
        });
      }
    });
  };

  return (
    <>
      {loading && <Loading />}
      {showButton && (
        <Btn
            text={loading ? 'Cancelando...' : 'Cancelar'}
            action={handleClick}
            disabled={loading}
            color="error"
            variant="outlined"
            />
      )}
    </>
  );
};

export default BotonSwal;

